<template>
    <section class="QuoteElement ContentSection ContentSection--hasclippath">
        <div>
            <h2 v-html="properties.quote"></h2>
            <svg xmlns="http://www.w3.org/2000/svg" width="107" height="263" viewBox="0 0 107 263">
                <text id="_" data-name="”" transform="translate(0 211)" :fill="pageData.color" font-size="224" font-family="Raleway-ExtraBold, Raleway" font-weight="800"><tspan x="0" y="0">”</tspan></text>
            </svg>
        </div>
    </section>
</template>
<script>
export default {
    props: ["properties", "pageData"]
}
</script>
<style lang="scss">
@import '@/assets/sass/_responsiveness.scss';
    .QuoteElement {
        display: flex;
        justify-content: center;
        padding: 200px 0 150px 0;
        background: #fff;

        &>div {
            position: relative;
            width: 100%;
            max-width: var(--content-max-width);
            padding: var(--content-padding);
        }

        h2 {
            max-width: auto;
            padding: 0;
            text-align: left;
        }

        svg {
            position: absolute;
            right: 20px;    
            top: -130px;
        }


        @include mobile-only {
            padding: 150px 0 100px 0;
        }
    }
</style>